import SText from '../../../components/SText'
import Colors from '../../../components/utils/Colors'
import styles from './DownloadAppModal.module.scss'
import closeBtn from "../../../assets/images/closeModal.svg";
import { GOOGLE_PLAY, APPLE_STORE } from '../../../constants/urls';

const DownloadAppModal = ({ isOpen, setClose }) => {
    return isOpen && (
        <div className={ styles.wrap }>
            <div className={ styles.container }>
                <div className={ styles.window }>
                    <SText size={ 24 } weight={ 500 } className={ styles.message }>Спасибо! Мы приняли ваш заказ!</SText>
                    <SText size={ 16 } weight={ 900 } className={ styles.text_center }>Хотите добавить товар к заказу, отследить курьера или связаться <br></br> с диспетчером?</SText>
                    <SText size={ 20 } weight={ 900 } className={ styles.text_center } color={ Colors.green }>Это удобно сделать <br></br> в нашем приложении!</SText>
                    {/* <hr className={ styles.separator } />
                    <div className={ styles.text_wrap }>
                        <div className={ styles.column_text }>
                            <SText size={ 16 } weight={ 900 } className={ styles.text_center }>Хотите добавить товар к заказу, отследить курьера или связаться <br></br> с диспетчером?</SText>
                            <SText size={ 20 } weight={ 900 } className={ styles.text_center } color={ Colors.green }>Это удобно сделать <br></br> в нашем приложении!</SText>
                            <div className={ styles.mobile }>
                                <img src={ "/images/mobile.png" } alt="mobile" />
                            </div>
                        </div>
                        <div className={ styles.column_text }>
                            <div className={ styles.text_icon }>
                                <img src={ "/images/petard.png" } alt="petard" className={ styles.petard } />
                                <SText size={ 16 } weight={ 500 } className={ styles.text_center } style={ { textAlign: "left" } }>Мы также дарим вам 300 бонусных баллов <br></br> на ваш первый заказ, оформленный через приложение</SText>
                            </div>
                            <SText size={ 16 } weight={ 900 } className={ styles.text_center } color={ Colors.green }>Наведите камеру смартфона на QR код для скачивания приложения</SText>
                            <img src={ "/images/qr.png" } alt="qr" className={ styles.qr } />
                            <div className={ styles.app_markets }>
                                <a href={ APPLE_STORE }>
                                    <img src={ "/icons/apple_store.svg" } alt="apple store" />
                                </a>
                                <a href={ GOOGLE_PLAY }>
                                    <img src={ "/icons/google_play.svg" } alt="google play" />
                                </a>
                            </div>
                        </div>
                    </div> */}
                </div>
                <img src={ closeBtn } alt="cross" className={ styles.cross } onClick={ () => setClose(false) } />
            </div>
        </div>
    )
}

export default DownloadAppModal